module.exports = __webpack_public_path__ + "static/img/1.5d73f46.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/3/1.png
// module id = aDZv
// module chunks = 0